/** Public settings of the customer account site. Nothing here is secret. */
export const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? "https://api.frame-flow.ai",
  /** Google sign-in and sign-up (Firebase Authentication's Google provider, client on app.frame-flow.ai). */
  googleSignIn: true,
  /** The contact the marketing site offers for joining the beta. */
  whatsappUrl:
    "https://wa.me/972539666404?text=" + encodeURIComponent("היי, נרשמתי ל-FrameFlow ואשמח להפעיל את החשבון."),
  marketingSiteUrl: "https://frame-flow.ai",
  termsUrl: "/legal/terms",
  privacyUrl: "/legal/privacy",
} as const;
